// Hide the "+" stepper and lock the quantity input for products limited to a
// single unit (see SINGLE_QTY_* in constants.js). Covers both the cart page
// (custom-main-cart-item) and the cart drawer, and re-applies after re-renders.
(function () {
  function lockControls(variantId) {
    // Cart page (custom-main-cart-item.liquid)
    var pageInput = document.getElementById('updates_' + variantId);
    if (pageInput) {
      pageInput.readOnly = true;
      var pageBox = pageInput.closest('.quantity-input');
      var pagePlus = pageBox && pageBox.querySelector('.quantity-btn.plus');
      if (pagePlus) pagePlus.style.display = 'none';
    }

    // Cart drawer (cart-drawer.liquid)
    document
      .querySelectorAll('.quantity__input[data-quantity-variant-id="' + variantId + '"]')
      .forEach(function (drawerInput) {
        drawerInput.readOnly = true;
        var qty = drawerInput.closest('quantity-input');
        var drawerPlus = qty && qty.querySelector('button[name="plus"]');
        if (drawerPlus) drawerPlus.style.display = 'none';
      });
  }

  function refreshAndLock() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cart.items.forEach(function (item) {
          if (isSingleQtyCartItem(item)) lockControls(item.variant_id);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshAndLock();

    // Re-lock after add-to-cart / quantity changes that publish a cart update.
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refreshAndLock, 100);
      });
    }

    // Re-lock when the drawer re-renders (it refreshes its HTML without a pub/sub
    // event). Watches childList only, so toggling button styles won't loop.
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(refreshAndLock, 150);
      }).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
